:host {
  display: block;

  .no-price {
    text-align: left;
    margin: 0;
    line-height: 1.3;
  }
}
